import { useMonthOptions } from '@/src/hooks/use-month-options/useMonthOptions'
import { VpSelect, VpSelectOption } from '@vtmn-play/react'

interface Props {
  value: string
  onChange: (value: string) => void
  className?: string
}

export const MonthFilterSelect = ({ value, onChange, className }: Props) => {
  const options = useMonthOptions()

  return (
    <VpSelect
      data-testid="month-filter-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={className}
    >
      {options.map((opt) => (
        <VpSelectOption
          data-testid={`month-filter-option-${opt.value}`}
          key={opt.value}
          value={opt.value}
        >
          {opt.label}
        </VpSelectOption>
      ))}
    </VpSelect>
  )
}
